<template>
	<div>
		<div class="modal modal-calendar fade" id="eventModal" role="dialog" aria-labelledby="eventModalLabel" aria-hidden="true">
		  	<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl" role="document">
		    	<div class="modal-content">
			      	<preloader v-if="event.loading"></preloader>
			      	<div class="modal-header rounded-top pb-2">
			      		<button 
							type="button" 
							class="btn btn-sm btn-link btn-transparent order-1" 
							data-dismiss="modal" 
							aria-label="Close" 
							v-tooltip="'Cerrar'" 
							:disabled="event.loading"
							v-if="event.tipo=='edit'">
		          			<i class="material-icons">close</i>
			        	</button>
			      		<div class="pr-3 flex-fill order-2">
			      			<div v-if="event.tipo!='ver'">
			    				<input type="text" name="titulo" maxlength="50" class="form-control" placeholder="Añade un título" noCounter v-model="event.TITULO">
			    			</div>
		    			</div>

		    			<div class="text-right order-3">
							<button 
				        		type="button" 
				        		class="btn btn-sm btn-link btn-transparent" 
				        		v-tooltip="'Editar'" 
				        		v-if="event.ESTATUS=='A' && event.tipo=='ver'" 
				        		v-on:click.prevent="editTarea()" 
				        		:disabled="event.loading">
								<i class="material-icons">edit</i>
							</button>

							<button 
								type="button" 
								class="btn btn-sm btn-link btn-transparent" 
								v-tooltip="'Eliminar'" 
								v-on:click.prevent="deleteEvent()" 
								v-if="event.ESTATUS=='A' && event.tipo=='ver'"
								:disabled="event.loading">
								<i class="material-icons">delete</i>
							</button>

							<button 
								type="button" 
								class="btn btn-primary" 
								v-if="event.tipo=='edit'" 
								v-on:click.prevent="updateTarea()" 
								v-tooltip="'Actualizar'" 
								:disabled="event.loading">
								<span v-if="event.loading">
									<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
									Cargando...
								</span>
								<span v-else>
									Actualizar
								</span>
							</button>

							<div :class="{'btn-group':true, 'd-none d-lg-inline-block':event.tipo=='edit'}" v-if="event.tipo!='create' && (event.ESTATUS=='A')">
								<button type="button" :class="{'btn dropdown-toggle dropdown-toggle-nodrop':true, 'btn-sm btn-link btn-transparent':event.tipo!='edit'}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									<span v-if="event.tipo!='edit'">
										<i class="material-icons">more_vert</i>
									</span>
									<span v-else>
										Más acciones <i class="material-icons">arrow_drop_down</i>
									</span>
								</button>
								<div class="dropdown-menu dropdown-menu-right">
									<button 
										type="button" 
										class="dropdown-item" 
										:disabled="event.loading"
										v-on:click.prevent="duplicateTarea()">
										<i class="material-icons">filter_none</i>
										Duplicar
									</button>

									<button 
										type="button" 
										class="dropdown-item" 
										v-on:click.prevent="cerrarTarea()" 
										v-if="event.ESTATUS=='A'"  
										:disabled="event.loading">
										<i class="material-icons">not_interested</i>
										Cerrar Tarea
									</button>

									<button 
										type="button" 
										class="dropdown-item" 
										v-on:click.prevent="deleteEvent()" 
										v-if="event.ESTATUS=='A'"
										:disabled="event.loading">
										<i class="material-icons">delete</i> Eliminar
									</button>
								</div>
							</div>

							<button 
								type="button" 
								class="btn btn-sm btn-link btn-transparent" 
								data-dismiss="modal" 
								aria-label="Close" 
								v-tooltip="'Cerrar'" 
								:disabled="event.loading"
								v-if="event.tipo!='edit'">
			          			<i class="material-icons">close</i>
				        	</button>
			    		</div>
			      	</div>

			      	<div class="modal-body pt-0">
			      		<div class="row">
			      			<div class="col-md-12" v-if="event.tipo=='ver'">
			      				<div class="d-flex mb-2">
			      					<span class="align-self-top mr-3 font-weight-bold">
						      			<i class="material-icons text-primary">lens</i>
						      		</span>
						      		<div class="w-100">
							      		<h3 class="m-0">
							      			{{ event.TITULO || '(Sin título)'}}
							      		</h3>
								        <small class="text-muted">{{ event.FECHA }}</small>
							      	</div>
								</div>
			      			</div>

			      			<div class="col-md-12" v-if="event.tipo=='ver' && event.VIDEOLLAMADA">
			      				<div class="d-flex mb-2">
			      					<span class="align-self-top mr-3 font-weight-bold" v-tooltip="Videollamada">
						      			<i class="material-icons">video_call</i>
						      		</span>
						      		<div class="w-100">
							      		<a :href="event.VIDEOLLAMADA" target="_blank">{{event.VIDEOLLAMADA}}</a>
							      	</div>
								</div>
			      			</div>

			      			<div class="col-md-6">
			      				<p v-if="event.tipo=='edit'" class="text-muted m-0">Detalle</p>
			      				<div>
			      					<div class="form-row mb-2" v-if="event.tipo!='ver'">
							      		<span class="col-1 font-weight-bold">
							      			<i class="material-icons text-secondary" v-tooltip="'Fecha'">query_builder</i>
							      		</span>
							      		<div class="col-11">
						      				<datetime name="date" v-model="event.FECHA"></datetime>

						      				<div class="text-danger" v-if="errors.fecha">
				                            	{{ arrayText(errors.fecha) }}
				                            </div>
							      		</div>
							      	</div>

							      	<div class="form-row mb-2" v-if="event.tipo!='ver'">
							      		<span class="col-1 font-weight-bold">
							      			<i class="material-icons text-secondary" v-tooltip="'Videollamada'">video_call</i>
							      		</span>
							      		<div class="col-11">
						      				<div class="custom-control custom-checkbox">
						      					<input name="videollamada" type="checkbox" v-model="event.VIDEOLLAMADA" class="custom-control-input" id="videollamadaTarea">
						      					<label class="custom-control-label" for="videollamadaTarea">
						      						¿Añadir videollamada?
						      					</label>
						      				</div>

						      				<div class="text-danger" v-if="errors.videollamada">
				                            	{{ arrayText(errors.videollamada) }}
				                            </div>
							      		</div>
							      	</div>

			      					<div class="form-row mb-2">
							      		<span class="col-1 font-weight-bold">
							      			<i class="material-icons text-secondary" v-tooltip="'Tipo'">filter_list</i>
							      		</span>
							      		<div class="col-11">
							      			<select2 class="w-100" :options="{allowClear: true, width: '100%'}" v-model="event.TIPO_TAREA" :disabled="event.tipo=='ver'" title="Añade un tipo">
							      				<option data-icon="fa fa-phone-square mr-2 text-primary">
						    						Llamada
						    					</option>
					                            <option data-icon="fa fa-car mr-2 text-danger">
					                            	Visita
					                            </option>
					                            <option data-icon="fa fa-envelope mr-2 text-secondary">
					                            	Correo
					                        	</option>
					                            <option data-icon="fab fa-whatsapp mr-2 text-success">		WhatsApp
					                            </option>
					                            <option data-icon="fa fa-user mr-2 text-muted">
					                            	Seguimiento a Cliente
					                            </option>
					                            <option data-icon="fa fa-cogs mr-2 text-dark">
					                            	Soporte Interno
					                            </option>
			                            	</select2>
			                            	<div class="text-danger" v-if="errors.tipo_tarea">
				                            	{{ arrayText(errors.tipo_tarea) }}
				                            </div>
							      		</div>
							      	</div>

							      	<div class="form-row mb-2" v-if="event.CODIGO_CLIENTE || event.tipo =='create'">
							      		<span class="col-1 font-weight-bold">
							      			<i class="material-icons text-secondary" v-tooltip="'Cliente'">contacts</i>
							      		</span>
							      		<div class="col-11 position-relative">
							      			<div v-if="event.tipo=='ver'" class="row">
									      		<div class="col-md-12" v-if="event.cliente.CODIGO_CLIENTE">
									      			<small>Información cliente</small>
									      		</div>
												<div class="media mb-2 col-md-12" v-if="event.cliente.NOMBRE_CLIENTE">
										      		<span class="align-self-center mr-3 font-weight-bold">
										      			<i class="material-icons text-secondary" v-tooltip="'Cliente'">face</i>
										      		</span>
										      		<div class="media-body overflow-auto">
										      			<a :href="'clientes/'+event.cliente.CODIGO_CLIENTE" style="word-break: break-word !important;overflow-wrap: break-word !important;">
										      				{{ event.cliente.NOMBRE_CLIENTE }}
										      			</a>
										      		</div>
										      	</div>

										      	<div class="col-md-4 mb-2" v-if="event.cliente.CELULAR">
										      		<a :href="'tel:'+phoneNumber(event.cliente.CELULAR)" target="_blank" class="btn btn-info btn-block text-white" v-tooltip="'Celular'">
										      			<div class="d-flex align-items-center">
											      			<i class="material-icons ml-auto">phone_iphone</i>
											      			<div class="w-100 text-center">
									      						{{event.cliente.CELULAR}}
											      			</div>
										      			</div>
								      				</a>
										      	</div>

										      	<div class="col-md-4 mb-2" v-if="event.cliente.TELEFONO">
										      		<a :href="'tel:'+phoneNumber(event.cliente.TELEFONO)" target="_blank" class="btn btn-light btn-block" v-tooltip="'Teléfono'">
										      			<div class="d-flex align-items-center">
											      			<i class="material-icons" v-tooltip="'Teléfono'">local_phone</i>
											      			<div class="w-100 text-center">
									      						{{event.cliente.TELEFONO}}
											      			</div>
										      			</div>
								      				</a>
										      	</div>

										      	<div class="col-md-4 mb-2" v-if="event.cliente.TELEFONO || event.cliente.CELULAR">
										      		<a :href="'https://api.whatsapp.com/send?phone='+phoneNumber(event.cliente.CELULAR || event.cliente.TELEFONO)" target="_blank" class="btn btn-success btn-block text-white" v-tooltip="'WhatsApp'">
								      					<div class="d-flex align-items-center">
										      				<i class="fab fa-whatsapp"></i>
								      						<div class="w-100 text-center">
								      							Ir a WhatsApp
								      						</div>
								      					</div>
								      				</a>
										      	</div>

										      	<div class="media mb-2 col-md-12" v-if="event.cliente.EMAIL">
										      		<span class="align-self-center mr-3 font-weight-bold">
										      			<i class="material-icons text-secondary" v-tooltip="'Correo'">email</i>
										      		</span>
										      		<div class="media-body overflow-auto">
										      			<copy :text="event.cliente.EMAIL" msg="El correo electrónico ha sido copiado en el portapapeles correctamente">
										      				<a :href="'mailto:'+event.cliente.EMAIL" target="_top" v-tooltip="'Enviar correo'">
										      					{{event.cliente.EMAIL}}
										      				</a>
										      			</copy>
										      		</div>
										      	</div>
											</div>
							      			<catalogo-clientes id="clientesModal" v-model="event.CODIGO_CLIENTE" title="Añade un cliente" class="position-relative" v-else></catalogo-clientes>
							      			<div class="text-danger" v-if="errors.cliente">
				                            	{{ arrayText(errors.cliente) }}
				                            </div>
							      		</div>
							      	</div>

					    			<div class="form-row mb-2">
							      		<span class="col-1 font-weight-bold">
							      			<i class="material-icons text-secondary" v-tooltip="'Oportunidad'">shop</i>
							      		</span>
							      		<div class="col-11">
							      			<a :href="'oportunidades/'+event.CODIGO_OPORTUNIDAD" class="m-0" v-if="event.tipo=='ver'" style="word-break: break-word !important;overflow-wrap: break-word !important;">
							      				{{event.oportunidad.DESCRIPCION_OPORTUNIDAD}}
							      			</a>
							      			<catalogo-oportunidades v-model="event.CODIGO_OPORTUNIDAD" title="Añade una oportunidad" v-else>
			                            	</catalogo-oportunidades>
			                            	
			                            	<div class="text-right">
			                            		<a :href="urlAdjuntos" v-if="urlAdjuntos">
								      				Ir a los adjuntos de la oportunidad
								      			</a>
			                            	</div>

			                            	<div class="text-danger" v-if="errors.oportunidad">
				                            	{{ arrayText(errors.oportunidad) }}
				                            </div>
							      		</div>
							      	</div>

							      	<div class="form-row mb-2">
							      		<span class="col-1 font-weight-bold">
							      			<i class="material-icons text-secondary" v-tooltip="'Usuario Asignado'">person</i>
							      		</span>
							      		<div class="col-11">
							      			<span class="m-0" v-if="event.tipo=='ver'">
							      				{{ event.usuario.NOMBRE }}
							      				<span v-if="event.usuario.CORREO">
							      					({{ event.usuario.CORREO }})
							      				</span>
							      			</span>

							      			<catalogo-usuarios v-model="event.USUARIO_ASIGNADO" title="Añade un usuario" v-else></catalogo-usuarios>
			                            	<div class="text-danger" v-if="errors.usuario_asignado">
				                            	{{ arrayText(errors.usuario_asignado) }}
				                            </div>
							      		</div>
							      	</div>

							      	<div class="form-row mb-2">
							      		<span class="col-1 font-weight-bold">
							      			<i class="material-icons text-secondary" v-tooltip="'Notas'">note</i>
							      		</span>
							      		<div class="col-11">
							      			<span class="m-0" v-if="event.tipo=='ver'" style="white-space: pre-line;">
							      				{{ event.NOTAS }}
							      			</span>
							      			<div v-else>
							      				<textarea class="form-control" placeholder="Añade una descripción" v-model="event.NOTAS"></textarea>
							      				<div class="text-danger" v-if="errors.notas">
					                            	{{ arrayText(errors.notas) }}
					                            </div>
							      			</div>
							      		</div>
							      	</div>

							      	<div class="form-row mb-2" v-if="event.ESTATUS">
							      		<span class="col-1 font-weight-bold">
							      			<i class="material-icons text-secondary" v-tooltip="'Estado'">info</i>
							      		</span>
							      		<div class="col-11">
							      			<span class="m-0" v-if="event.ESTATUS=='A'">
							      				Abierta
							      			</span>

							      			<span class="m-0" v-if="event.ESTATUS=='C'">
							      				Cerrada
							      			</span>
							      		</div>
							      	</div>

							      	<div class="form-row mb-2" v-if="event.oportunidad.vendedor.NOMBRE_VENDEDOR">
							      		<span class="col-1 font-weight-bold">
							      			<i class="material-icons text-secondary" v-tooltip="'Vendedor'">assignment_ind</i>
							      		</span>
							      		<div class="col-11">
							      			<span class="m-0">
							      				{{ event.oportunidad.vendedor.NOMBRE_VENDEDOR }}
							      			</span>
							      		</div>
							      	</div>
								</div>
			      			</div>
			      			<div class="col-md-6">
			      				<ul class="nav nav-tabs" id="myTab" role="tablist">
									<li class="nav-item">
										<a class="nav-link active" id="invitados-tab" data-toggle="tab" href="#invitados" role="tab" aria-controls="invitados" aria-selected="true">Invitados</a>
									</li>
									<li class="nav-item">
										<a class="nav-link" id="adjuntos-tab" data-toggle="tab" href="#adjuntos" role="tab" aria-controls="adjuntos" aria-selected="false">Adjuntos</a>
									</li>
								</ul>
								<div class="tab-content" id="myTabContent">
									<div class="tab-pane fade show active py-3" id="invitados" role="tabpanel" aria-labelledby="invitados-tab">
										<input type="email" name="invitados" v-bind:class="{'form-control':true, 'border border-danger':errorInvitado}" v-model="invitado" ref="invitado" placeholder="Añade invitados" v-on:keyup.enter="addInvitado"
					      				:disabled="loading.emails" v-if="event.tipo!='ver'">
					      				<preloader v-if="loading.emails"></preloader>
					      				
					      				<div class="text-danger" v-if="errorInvitado">
			                            	{{ errorInvitado }}
			                            </div>

					      				<ul v-if="event.invitados.length>0" class="list-unstyled">
											<li v-for="(invitado, index) in event.invitados" class="media p-1">
												<div class="mr-3 rounded-circle p-1" style="background-color: #e0e0e0">
													<i class="material-icons text-muted">person</i>
												</div>
												<div class="media-body overflow-auto">
													<copy :text="invitado.EMAIL" msg="El correo electrónico ha sido copiado en el portapapeles" class="d-inline-block">
									      				<a :href="'mailto:'+invitado.EMAIL" target="_top" v-tooltip="'Enviar correo'">
									      					{{invitado.EMAIL}}
									      				</a>
									      			</copy>
								      				<a href="#" class="btn btn-secondary btn-sm float-right" v-tooltip="'Envíar invitación'" v-on:click.prevent="sendEmail(invitado)" v-if="invitado.ENVIO_CORREO!=1 && event.tipo!='ver'">
								      					<i class="fas fa-paper-plane"></i>
								      				</a>
												</div>
												<div class="ml-3">
													<button type="button" class="btn btn-sm btn-link" v-on:click="deleteInvitado(event.tipo=='create' ? index : invitado.CODIGO)" v-if="event.tipo!='ver'">
														<i class="material-icons">delete</i>
													</button>
												</div>
											</li>
										</ul>
									</div>
									<div class="tab-pane fade" id="adjuntos" role="tabpanel" aria-labelledby="adjuntos-tab">
										<tareas-adjuntos :tarea="event.CODIGO_TAREA" ref="adjuntosTareas" :disabled="(event.tipo=='ver') ? true : false" :upload="(event.tipo=='create') ? false : true" v-model="event.adjuntos"></tareas-adjuntos>
									</div>
								</div>
			      			</div>
			      		</div>


			      		<nav v-if="false">
							<div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
						    	<a class="nav-item nav-link active" id="nav-info-tab" data-toggle="tab" href="#nav-info" role="tab" aria-controls="nav-info" aria-selected="true">
						    		Información
						    	</a>
						    	<a class="nav-item nav-link" id="nav-adjuntos-tab" data-toggle="tab" href="#nav-adjuntos" role="tab" aria-controls="nav-adjuntos" aria-selected="false">
						    		Adjuntos
						    	</a>
						    	<a class="nav-item nav-link" id="nav-invitado-tab" data-toggle="tab" href="#nav-invitado" role="tab" aria-controls="nav-invitado" aria-selected="false">
						    		Invitados
						    	</a>
						    	<a class="nav-item nav-link" id="nav-otros-tab" data-toggle="tab" href="#nav-otros" role="tab" aria-controls="nav-otros" aria-selected="false" v-if="event.tipo=='ver'">
						    		Otros
						    	</a>
						  	</div>
						</nav>
						<div class="tab-content p-3" id="nav-tabContent" v-if="false">
							<div class="tab-pane fade show active" id="nav-info" role="tabpanel" aria-labelledby="nav-info-tab">
				    			<div class="media mb-2" v-if="event.tipo!='ver'">
						      		<span class="align-self-center mr-3 font-weight-bold">
						      			<i class="material-icons text-secondary" v-tooltip="'Tipo'">filter_list</i>
						      		</span>
						      		<div class="media-body overflow-auto">
						      			<select2 class="w-100" :options="{allowClear: true, width: '100%'}" v-model="event.TIPO_TAREA">
						      				<option data-icon="fa fa-phone-square mr-2 text-primary">
					    						Llamada
					    					</option>
				                            <option data-icon="fa fa-car mr-2 text-danger">
				                            	Visita
				                            </option>
				                            <option data-icon="fa fa-envelope mr-2 text-secondary">
				                            	Correo
				                        	</option>
				                            <option data-icon="fab fa-whatsapp mr-2 text-success">		WhatsApp
				                            </option>
				                            <option data-icon="fa fa-user mr-2 text-muted">
				                            	Seguimiento a Cliente
				                            </option>
				                            <option data-icon="fa fa-cogs mr-2 text-dark">
				                            	Soporte Interno
				                            </option>
		                            	</select2>
		                            	<div class="text-danger" v-if="errors.tipo_tarea">
			                            	{{ arrayText(errors.tipo_tarea) }}
			                            </div>
						      		</div>
						      	</div>

								<div class="media mb-2">
						      		<span class="align-self-top mr-3 font-weight-bold">
						      			<i class="material-icons text-secondary" v-tooltip="'Fecha'">query_builder</i>
						      		</span>
						      		<div class="media-body overflow-auto">
						      			<span class="m-0" v-if="event.tipo=='ver'">
						      				{{ event.FECHA }}
						      			</span>
						      			<div v-else>
						      				<datetime name="date" v-model="event.FECHA"></datetime>

						      				<div class="text-danger" v-if="errors.fecha">
				                            	{{ arrayText(errors.fecha) }}
				                            </div>
						      			</div>
						      		</div>
						      	</div>

						      	<div class="media mb-2">
						      		<span class="align-self-center mr-3 font-weight-bold">
						      			<i class="material-icons text-secondary" v-tooltip="'Oportunidad'">shop</i>
						      		</span>
						      		<div class="media-body overflow-auto">
						      			<a :href="'oportunidades/'+event.CODIGO_OPORTUNIDAD" class="m-0" v-if="event.tipo=='ver'" style="word-break: break-word !important;overflow-wrap: break-word !important;">
						      				{{event.oportunidad.DESCRIPCION_OPORTUNIDAD}}
						      			</a>
						      			<catalogo-oportunidades v-model="event.CODIGO_OPORTUNIDAD" v-else></catalogo-oportunidades>
		                            	<div class="text-danger" v-if="errors.oportunidad">
			                            	{{ arrayText(errors.oportunidad) }}
			                            </div>
						      		</div>
						      	</div>

						      	<div class="media mb-2">
						      		<span class="align-self-center mr-3 font-weight-bold">
						      			<i class="material-icons text-secondary" v-tooltip="'Usuario Asignado'">person</i>
						      		</span>
						      		<div class="media-body overflow-auto">
						      			<span class="m-0" v-if="event.tipo=='ver'">
						      				{{ event.usuario.NOMBRE }}
						      				<span v-if="event.usuario.CORREO">
						      					({{ event.usuario.CORREO }})
						      				</span>
						      			</span>

						      			<catalogo-usuarios v-model="event.USUARIO_ASIGNADO" v-else></catalogo-usuarios>
		                            	<div class="text-danger" v-if="errors.usuario_asignado">
			                            	{{ arrayText(errors.usuario_asignado) }}
			                            </div>
						      		</div>
						      	</div>

						      	<div class="media mb-2">
						      		<span class="align-self-center mr-3 font-weight-bold">
						      			<i class="material-icons text-secondary" v-tooltip="'Notas'">note</i>
						      		</span>
						      		<div class="media-body overflow-auto">
						      			<span class="m-0" v-if="event.tipo=='ver'" style="white-space: pre-line;">
						      				{{ event.NOTAS }}
						      			</span>
						      			<div v-else>
						      				<textarea class="form-control" placeholder="Notas" v-model="event.NOTAS" maxlength="1000"></textarea>
						      				<div class="text-danger" v-if="errors.notas">
				                            	{{ arrayText(errors.notas) }}
				                            </div>
						      			</div>
						      		</div>
						      	</div>

						      	<div class="media mb-2" v-if="event.ESTATUS">
						      		<span class="align-self-center mr-3 font-weight-bold">
						      			<i class="material-icons text-secondary" v-tooltip="'Estado'">info</i>
						      		</span>
						      		<div class="media-body overflow-auto">
						      			<span class="m-0" v-if="event.ESTATUS=='A'">
						      				Abierta
						      			</span>

						      			<span class="m-0" v-if="event.ESTATUS=='C'">
						      				Cerrada
						      			</span>
						      		</div>
						      	</div>

						      	<div class="media mb-2" v-if="event.oportunidad.vendedor.NOMBRE_VENDEDOR">
						      		<span class="align-self-center mr-3 font-weight-bold">
						      			<i class="material-icons text-secondary" v-tooltip="'Vendedor'">assignment_ind</i>
						      		</span>
						      		<div class="media-body overflow-auto">
						      			<span class="m-0">
						      				{{ event.oportunidad.vendedor.NOMBRE_VENDEDOR }}
						      			</span>
						      		</div>
						      	</div>
								
						      	<div v-if="event.tipo=='ver'" class="row">
						      		<div class="col-md-12" v-if="event.cliente.CODIGO_CLIENTE">
						      			<small>Información cliente</small>
						      		</div>
									<div class="media mb-2 col-md-12" v-if="event.cliente.NOMBRE_CLIENTE">
							      		<span class="align-self-center mr-3 font-weight-bold">
							      			<i class="material-icons text-secondary" v-tooltip="'Cliente'">face</i>
							      		</span>
							      		<div class="media-body overflow-auto">
							      			<span class="m-0">
							      				{{ event.cliente.NOMBRE_CLIENTE }}
							      			</span>
							      		</div>
							      	</div>

							      	<div class="media mb-2 col-md-6" v-if="event.cliente.CELULAR">
							      		<span class="align-self-center mr-3 font-weight-bold">
							      			<i class="material-icons text-secondary" v-tooltip="'Celular'">phone_iphone</i>
							      		</span>
							      		<div class="media-body overflow-auto">
							      			<span class="m-0">
							      				<a :href="'tel:'+event.cliente.CELULAR">
							      					{{ event.cliente.CELULAR }}
							      				</a>
							      			</span>
							      		</div>
							      	</div>

							      	<div class="media mb-2 col-md-6" v-if="event.cliente.TELEFONO">
							      		<span class="align-self-center mr-3 font-weight-bold">
							      			<i class="material-icons text-secondary" v-tooltip="'Teléfono'">local_phone</i>
							      		</span>
							      		<div class="media-body overflow-auto">
							      			<span class="m-0">
							      				<a :href="'tel:'+event.cliente.TELEFONO">
							      					{{ event.cliente.TELEFONO }}
							      				</a>
							      			</span>
							      		</div>
							      	</div>

							      	<div class="media mb-2 col-md-12" v-if="event.cliente.EMAIL">
							      		<span class="align-self-center mr-3 font-weight-bold">
							      			<i class="material-icons text-secondary" v-tooltip="'Correo'">email</i>
							      		</span>
							      		<div class="media-body overflow-auto">
							      			<copy :text="event.cliente.EMAIL" msg="El correo electrónico ha sido copiado en el portapapeles correctamente">
							      				<a :href="'mailto:'+event.cliente.EMAIL" target="_top" v-tooltip="'Enviar correo'">
							      					{{event.cliente.EMAIL}}
							      				</a>
							      			</copy>
							      		</div>
							      	</div>
								</div>
							</div>
							<div class="tab-pane fade" id="nav-adjuntos" role="tabpanel" aria-labelledby="nav-adjuntos-tab">
								
							</div>
							<div class="tab-pane fade" id="nav-invitado" role="tabpanel" aria-labelledby="nav-invitado-tab">
								<div>
									<div v-if="event.tipo!='ver'">
							      		<small class="mb-0">
							      			Agregar los correos de las personas:
							      		</small>
							      		
										<autocomplete id="email-to" v-model="event.invitados" :emails="emails" placeholder="Correos" v-if="!loading.email"></autocomplete>
										<span v-else>
											Cargando...
										</span>
					                    <div class="text-danger" v-if="errors.errors">
			                            	{{ arrayText(errors.emails) }}
			                            </div>
							      	</div>
									<ul v-if="event.invitados.length>0 && event.tipo=='ver'" class="list-group list-group-flush">
										<li v-for="(invitado, index) in event.invitados" class="list-group-item">
											<copy :text="invitado.EMAIL" msg="El correo electrónico ha sido copiado en el portapapeles correctamente" class="d-inline-block">
							      				<a :href="'mailto:'+invitado.EMAIL" target="_top" v-tooltip="'Enviar correo'">
							      					{{invitado.EMAIL}}
							      				</a>

							      			</copy>
						      				<a href="#" class="btn btn-secondary btn-sm float-right" v-tooltip="'Envíar invitación'" v-on:click.prevent="sendEmail(invitado)" v-if="invitado.ENVIO_CORREO!=1">
						      					<i class="fas fa-paper-plane"></i>
						      				</a>
										</li>
									</ul>
									<div class="p-3" v-else>
										<empty icon="event_busy" title="No hay invitados." description="No se agregaron invitados a la tarea."></empty>
									</div>
								</div>
							</div>
							<div class="tab-pane fade" id="nav-otros" role="tabpanel" aria-labelledby="nav-otros-tab" v-if="event.tipo=='ver'">
								<div class="row">
									<div class="col-md-6">
										<div class="media mb-2">
								      		<span class="align-self-center mr-3 font-weight-bold">
								      			<i class="material-icons text-secondary" v-tooltip="'Fecha Creación'">date_range</i>
								      		</span>
								      		<div class="media-body overflow-auto">
								      			<span class="m-0">
								      				{{ event.FECHA_CREACION }}
								      			</span>
								      		</div>
								      	</div>	
									</div>

									<div class="col-md-6">
										<div class="media mb-2">
								      		<span class="align-self-center mr-3 font-weight-bold">
								      			<i class="material-icons text-secondary" v-tooltip="'Fecha Actualización'">update</i>
								      		</span>
								      		<div class="media-body overflow-auto">
								      			<span class="m-0">
								      				{{ event.FECHA_ACTUALIZACION }}
								      			</span>
								      		</div>
								      	</div>	
									</div>

									<div class="col-md-6">
										<div class="media mb-2">
								      		<span class="align-self-center mr-3 font-weight-bold">
								      			<i class="material-icons text-secondary" v-tooltip="'Creado Por'">supervisor_account</i>
								      		</span>
								      		<div class="media-body overflow-auto">
								      			<span class="m-0">
								      				{{ event.usuario_creado.NOMBRE }}
								      			</span>
								      		</div>
								      	</div>
									</div>

									<div class="col-md-6">
										<div class="media mb-2">
								      		<span class="align-self-center mr-3 font-weight-bold">
								      			<i class="material-icons text-secondary" v-tooltip="'Actualizado Por'">refresh</i>
								      		</span>
								      		<div class="media-body overflow-auto">
								      			<span class="m-0">
								      				{{ event.usuario_actualizado.NOMBRE }}
								      			</span>
								      		</div>
								      	</div>	
									</div>

									<div class="col-md-6">
										<div class="media mb-2">
								      		<span class="align-self-center mr-3 font-weight-bold">
								      			<i class="material-icons text-secondary" v-tooltip="'Creado Desde'">computer</i>
								      		</span>
								      		<div class="media-body overflow-auto">
								      			<span class="m-0">
								      				{{ event.CREADO_DESDE }}
								      			</span>
								      		</div>
								      	</div>	
									</div>

									<div class="col-md-6">
										<div class="media mb-2">
								      		<span class="align-self-center mr-3 font-weight-bold">
								      			<i class="material-icons text-secondary" v-tooltip="'Actualizado Desde'">edit_location</i>
								      		</span>
								      		<div class="media-body overflow-auto">
								      			<span class="m-0">
								      				{{ event.ACTUALIZADO_DESDE }}
								      			</span>
								      		</div>
								      	</div>	
									</div>
								</div>
							</div>
						</div>
			      	</div>
			      	<div class="modal-footer" v-if="event.tipo=='create'">
			      		<button 
							type="button" 
							class="btn btn-link" 
							data-dismiss="modal" 
							aria-label="Close" 
							v-tooltip="'Cancelar'" 
							:disabled="event.loading">
		          			Cancelar
			        	</button>
			      		<button 
							type="button" 
							class="btn btn-primary" 
							v-tooltip="event.loading ? 'Cargando...' : 'Guardar'" 
							v-on:click.prevent="storeTarea()" 
							:disabled="event.loading">
							<span v-if="event.loading">
								<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
								Cargando...
							</span>
							<span v-else>
								Guardar
							</span>
						</button>
			      	</div>
		    	</div>
		  	</div>
		</div>
		<div class="fixed-action-btn">
	        <a href="#" v-on:click.prevent="createTarea()" class="btn btn-primary btn-floating btn-large" v-tooltip="'Agregar Tarea'" data-toggle="tooltip" data-placement="bottom">
	            <i class="material-icons">add</i>
	        </a>
	    </div>
	</div>
</template>
<script>
	export default {
		data(){
			return {
				event: {
					tipo: '',
					TITULO: '',
					CODIGO_TAREA: '',
					CODIGO_OPORTUNIDAD: '',
					CODIGO_CLIENTE: '',
					FECHA: '',
					VIDEOLLAMADA: false,
					TIPO_TAREA: '',
					NOTAS: '',
					ESTATUS: '',
					FECHA_CREACION: '',
					CREADO_POR: '',
					CREADO_DESDE: '',
					FECHA_ACTUALIZACION: '',
					ACTUALIZADO_POR: '',
					ACTUALIZADO_DESDE: '',
					USUARIO_ASIGNADO: '',
					oportunidad: {
						DESCRIPCION_OPORTUNIDAD: '',
						vendedor: {
							NOMBRE_VENDEDOR: '',
						},

					},
					cliente: {
						CODIGO_CLIENTE: '',
						NOMBRE_CLIENTE: '',
						CELULAR: '',
						TELEFONO: '',
						CORREO: '',
					},
					usuario_creado: {
						CODIGO_USUARIO: '',
						NOMBRE: '',
						CORREO: '',
					},

					usuario_actualizado: {
						CODIGO_USUARIO: '',
						NOMBRE: '',
						CORREO: '',
					},

					usuario: {
						CODIGO_USUARIO: '',
						NOMBRE: '',
						CORREO: '',
					},
					invitados: [],
					loading: false
				},

				emails: [],
				invitado: '',
				errorInvitado: '',

				loading: {
					emails: false,
				},

				errors:[],
			}
		},

		mounted(){
			this.getEmails();
		},

		methods: {
			phoneNumber: function(value = ''){
				var tel = phoneUtil.parse(value, 'GT');
				return phoneUtil.format(tel, PNF.INTERNATIONAL);
			},

			str_pad(str, pad_length, pad_string, pad_type){
				var len = pad_length - str.length;
				if(len < 0) return str;    
				var pad = new Array(len + 1).join(pad_string);  
				if(pad_type == "STR_PAD_LEFT") return pad + str;
				return str + pad;
			},

			getData: function(value){
				this.$emit('update:data', value)
			},

			getEvent: function(event){
		    	this.event.tipo = 'ver';
		    	this.event.CODIGO_TAREA = event.CODIGO_TAREA;
				this.event.CODIGO_OPORTUNIDAD = event.CODIGO_OPORTUNIDAD;
				this.event.CODIGO_CLIENTE = event.CODIGO_CLIENTE;
				
				this.event.FECHA = moment(event.FECHA).format('DD-MM-YYYY HH:mm:ss');
				this.event.VIDEOLLAMADA = event.VIDEOLLAMADA
				this.event.TIPO_TAREA = event.TIPO_TAREA
				this.event.NOTAS = event.NOTAS
				this.event.TITULO = event.TITULO
				this.event.ESTATUS = event.ESTATUS
				this.event.FECHA_CREACION = event.FECHA_CREACION
				this.event.CREADO_POR = event.CREADO_POR
				this.event.USUARIO_ASIGNADO = event.USUARIO_ASIGNADO
				this.event.CREADO_DESDE = event.CREADO_DESDE
				this.event.FECHA_ACTUALIZACION = event.FECHA_ACTUALIZACION
				this.event.ACTUALIZADO_POR = event.ACTUALIZADO_POR
				this.event.ACTUALIZADO_DESDE = event.ACTUALIZADO_DESDE

				this.event.usuario_creado.CODIGO_USUARIO = event.usuario_creado ? event.usuario_creado.CODIGO_USUARIO : ''
				this.event.usuario_creado.NOMBRE = event.usuario_creado ? event.usuario_creado.NOMBRE : ''
				this.event.usuario_creado.CORREO = event.usuario_creado ? event.usuario_creado.CORREO : ''

				this.event.usuario_actualizado.CODIGO_USUARIO = event.usuario_actualizado ? event.usuario_actualizado.CODIGO_USUARIO : ''
				this.event.usuario_actualizado.NOMBRE = event.usuario_actualizado ? event.usuario_actualizado.NOMBRE : ''
				this.event.usuario_actualizado.CORREO = event.usuario_actualizado ? event.usuario_actualizado.CORREO : ''

				this.event.usuario.CODIGO_USUARIO = event.usuario ? event.usuario.CODIGO_USUARIO : ''
				this.event.usuario.NOMBRE = event.usuario ? event.usuario.NOMBRE : ''
				this.event.usuario.CORREO = event.usuario ? event.usuario.CORREO : ''

				if(event.oportunidad){
					this.event.oportunidad.DESCRIPCION_OPORTUNIDAD = event.oportunidad.DESCRIPCION_OPORTUNIDAD
					
					if(event.oportunidad.vendedor){
						this.event.oportunidad.vendedor.NOMBRE_VENDEDOR = event.oportunidad.vendedor.NOMBRE_VENDEDOR
					}

				}
				
				if(event.cliente){
					this.event.cliente.NOMBRE_CLIENTE = event.cliente.NOMBRE_CLIENTE
					this.event.cliente.CODIGO_CLIENTE = event.cliente.CODIGO_CLIENTE
					this.event.cliente.CELULAR = event.cliente.CELULAR
					this.event.cliente.TELEFONO = event.cliente.TELEFONO
					this.event.cliente.EMAIL = event.cliente.EMAIL
				}

				this.event.invitados = event.invitados || []
				this.errors = []

				$('#nav-tab a[href="#nav-info"]').tab('show');
		    	$('#eventModal').modal('show');
		    	this.$nextTick(() => {
			    	this.$refs.adjuntosTareas.getFiles();
			    });
		    },

		    duplicateTarea: function(){
		    	this.event.tipo = 'create'
		    	this.event.CODIGO_TAREA = ''
		    	this.event.errors = []
		    	
		    	$('#nav-tab a[href="#nav-info"]').tab('show')
		    	$('#eventModal').modal('show')
		    },

		    createTarea: function(){
		    	this.event.tipo = 'create'
		    	this.event.CODIGO_TAREA = ''
				this.event.CODIGO_OPORTUNIDAD = ''
				this.event.CODIGO_CLIENTE = ''
				this.event.FECHA = moment().format('DD-MM-YYYY HH:00:00')
				this.event.VIDEOLLAMADA = false
				this.event.TIPO_TAREA = ''
				this.event.NOTAS = ''
				this.event.TITULO = ''
				this.event.ESTATUS = ''
				this.event.FECHA_CREACION = ''
				this.event.CREADO_POR = ''
				this.event.USUARIO_ASIGNADO = this.usuario
				this.event.CREADO_DESDE = ''
				this.event.FECHA_ACTUALIZACION = ''
				this.event.ACTUALIZADO_POR = ''
				this.event.ACTUALIZADO_DESDE = ''
				this.event.oportunidad.DESCRIPCION_OPORTUNIDAD = ''
				//this.event.oportunidad.CODIGO_OPORTUNIDAD = ''
				this.event.oportunidad.vendedor.NOMBRE_VENDEDOR = ''
				this.event.cliente.NOMBRE_CLIENTE = ''
				this.event.cliente.CODIGO_CLIENTE = ''
				this.event.cliente.CELULAR = ''
				this.event.cliente.TELEFONO = ''
				this.event.cliente.CORREO = ''
				this.event.usuario_creado.CODIGO_USUARIO = ''
				this.event.usuario_creado.NOMBRE = ''
				this.event.usuario_creado.CORREO = ''
				
				this.event.usuario_actualizado.CODIGO_USUARIO = ''
				this.event.usuario_actualizado.NOMBRE = ''
				this.event.usuario_actualizado.CORREO = ''
				
				this.event.usuario.CODIGO_USUARIO = ''
				this.event.usuario.NOMBRE = ''
				this.event.usuario.CORREO = ''

				this.event.invitados = []
				this.event.errors = []
				$('#nav-tab a[href="#nav-info"]').tab('show');
		    	$('#eventModal').modal('show');
		    	this.$nextTick(() => {
		    		this.$refs.adjuntosTareas.resetField()
			    });
		    },

		    addEvent: function(day, validation){
		    	if(validation){
			    	this.createTarea();
			    	this.event.FECHA = moment(day.date).format('DD-MM-YYYY HH:00:00');
			    	this.event.errors = []
		    	}
		    },

		    editTarea: function(){
		    	this.event.tipo = 'edit'
		    	this.event.errors = []
		    	this.$nextTick(() => {
			    	this.$refs.adjuntosTareas.getFiles();
			    });
		    },

		    updateTarea :function(){
		    	var url = 'api/tareas/'+this.event.CODIGO_TAREA
		    	this.event.loading = true
		    	this.event.errors = []

		    	axios.put(url, {
		    		fecha: this.event.FECHA,
		    		tipo_tarea: this.event.TIPO_TAREA,
		    		oportunidades: this.event.CODIGO_OPORTUNIDAD,
		    		cliente: this.event.CODIGO_CLIENTE,
		    		usuario_asignado: this.event.USUARIO_ASIGNADO,
		    		notas: this.event.NOTAS,
		    		titulo: this.event.TITULO
		    	})
		    	.then(response => {
		    		this.$toasted.show('Tarea actualizada');
		    		$('#eventModal').modal('hide');
		    		this.getData(this.dateContext);
		    	}).catch(error=>{
		    		console.log(error.response);
		    		this.$toasted.show('Error al actualizar.');
		    		if (error.response.status == 422 & typeof(error.response.data.errors) != "undefined") {
                        this.errors = error.response.data.errors;
                    }
		    	}).then(()=>{
		    		this.event.loading = false;
		    	});
		    },

			storeTarea: function(){
				var url = 'api/tareas'
				this.event.loading = true
				this.event.errors = []

		    	axios.post(url, {
		    		fecha: this.event.FECHA,
		    		videollamada: this.event.VIDEOLLAMADA,
		    		tipo_tarea: this.event.TIPO_TAREA,
		    		oportunidades: this.event.CODIGO_OPORTUNIDAD,
		    		cliente: this.event.CODIGO_CLIENTE,
		    		usuario_asignado: this.event.USUARIO_ASIGNADO,
		    		notas: this.event.NOTAS,
		    		titulo: this.event.TITULO,
		    		invitados: this.event.invitados,
		    	})
		    	.then(response => {
		    		this.getData(this.dateContext)
		    		this.getEvent(response.data)
		    		//this.editTarea()
		    		this.event.CODIGO_TAREA = response.data.CODIGO_TAREA
	    			
	    			
	    			this.$nextTick(() => {
		    			this.$refs.adjuntosTareas.uploadFile().then(res=>{
		    				this.$toasted.show('La tarea ha sido agregada.');
		    				$('#eventModal').modal('hide');
		    			}).catch(err => {
		    				this.$toasted.show('Error al agregar adjuntos.');
		    			});
		    		})
		    	}).catch(error=>{
		    		console.log(error);
		    		this.$toasted.show('Error al agregar.');
		    		if (error.response.status == 422 & typeof(error.response.data.errors) != "undefined") {
                        this.errors = error.response.data.errors;
                    }
		    	}).then(()=>{
		    		this.event.loading = false;
		    	});
			},

		    cerrarTarea: function(){
		    	var url = 'api/tareas/'+this.event.CODIGO_TAREA+'/cerrar';
		    	this.event.loading = true
		    	this.event.errors = []

		    	axios.put(url)
		    	.then(response => {
		    		this.$toasted.show('Tarea cerrada');
		    		this.getData(this.dateContext);
		    		$('#eventModal').modal('hide');
		    	}).catch(error=>{
		    		console.log(error.response);
		    		this.$toasted.show('Error al cerrar tarea');
		    	}).then(()=>{
		    		this.event.loading = false;
		    	});
		    },

		    deleteEvent: function(){
		    	this.event.errors = []
		    	if(this.event.CODIGO_TAREA){
		    		var $module = this;
			    	$.confirm({
	                    title: '¿Estás seguro?',
	                    content: '¡Ya no podrás recuperar esta información!',
	                    theme: 'supervan', // 'material', 'bootstrap'
	                    buttons: {
	                        Confirmar: function () {
	                            $module.deleteEventForced();
	                        },
	                        Cancelar: function () {

	                        },
	                    }
	                });
		    	}
		    },

		    deleteEventForced: function(){
		    	this.event.errors = []
		    	if(this.event.CODIGO_TAREA){
		    		this.event.loading = true;
		    		var url = 'api/tareas/'+this.event.CODIGO_TAREA;

		    		axios.delete(url)
					.then(response => {
						this.$toasted.show('Tarea eliminada');
			    		this.getData(this.dateContext);
			    		$('#eventModal').modal('hide');
					}).catch(error => {
						console.log(error);
						console.log(error.response);
						this.$toasted.show('Error al eliminar la tarea.');
					}).then(()=>{
						this.event.loading = false;
					});
		    	}
		    },

		    getEmails: function(){
	    		var url = '/api/emails';
	    		this.loading.emails = true

	    		axios.get(url).then(response=>{
	    			this.emails = response.data
	    		}).catch(error=>{
	    			console.log(error.response)
	    		}).then(()=>{
	    			this.loading.emails = false
	    		});
	    	},

			cancelAndDeleteEvent: function(){
				this.deleteEventForced();
			},

			arrayText: function(text){
	            text = text.toString().replace('["', '')
	            text = text.toString().replace('"]"', '')

	            return text;
	        },

	        addInvitado: function(){
	        	this.errorInvitado = ''

	        	if (/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(this.invitado)){
	        			if (this.event.tipo == 'create') {
	        				this.event.invitados.push({
	        					EMAIL:this.invitado,
								ENVIO_CORREO:1,
								CODIGO:0,
	        				})
			    			this.invitado = ''
			        		this.errorInvitado = ''
			        		return;
	        			}

	        			var url = `api/tareas/${this.event.CODIGO_TAREA}/invitados`;
		    			this.loading.emails = true

	        			axios.post(url, {
	        				email: this.invitado
	        			}).then(response=>{
			    			this.event.invitados.push(response.data)
			    			this.invitado = ''
			        		this.errorInvitado = ''
			    		}).catch(error=>{
			    			this.$toasted.show('Error al agregar invitado.');
				    		if (error.response.status == 422 & typeof(error.response.data.errors) != "undefined") {
				    			var errors = error.response.data.errors
				    			if (errors.email) {
				    				this.errorInvitado = this.arrayText(errors.email)
				    			}
		                        
		                    }
			    		}).then(()=>{
			    			this.loading.emails = false
			    		});

	        	}else{
	        		this.errorInvitado = 'El correo es inválido'
	        	}
	        },

	        deleteInvitado: function(id){
	        	if (this.event.tipo == 'create') {
	        		//var index = this.event.invitados.findIndex(x=>x.CODIGO == id)
	        		this.event.invitados.splice(id, 1)
	        	}

	    		var url = `api/tareas/invitados/${id}`;
	    		this.loading.emails = true
	    		this.errorInvitado = ''

	    		axios.delete(url)
				.then(response => {
					this.getData(this.dateContext)

		    		var index = this.event.invitados.findIndex(x=>x.CODIGO == id)
		    		this.event.invitados.splice(index, 1)
				}).catch(error => {
					console.log(error)
					console.log(error.response)
					this.$toasted.show('Error al eliminar invitado.')
				}).then(()=>{
					this.loading.emails = false
				});
		    },

	        sendEmail: function(invitado){
	        	var url = '/api/emails/invitados/send/'+invitado.CODIGO;
	    		
	    		axios.post(url)
	    			.then(response=>{
	    				this.$toasted.show('Invitación envíada.');
	    				const index = this.event.invitados.findIndex(item => item.CODIGO == invitado.CODIGO)
	    				this.event.invitados.splice(index, 1, {
		                    CODIGO: invitado.CODIGO,
							CODIGO_TAREA: invitado.CODIGO_TAREA,
							EMAIL: invitado.EMAIL,
							FECHA_CREACION: invitado.FECHA_CREACION,
							FECHA_ACTUALIZACION: invitado.FECHA_ACTUALIZACION,
							CREADO_POR: invitado.CREADO_POR,
							ACTUALIZADO_POR: invitado.ACTUALIZADO_POR,
							CREADO_DESDE: invitado.CREADO_DESDE,
							ACTUALIZADO_DESDE: invitado.ACTUALIZADO_DESDE,
							ENVIO_CORREO: 1
		                })
	    			}).catch(error=>{
	    				this.$toasted.show('Error al Envíar invitación. Intente más tarde.');
		    			if (error.response.data) {
		    				this.$toasted.show(error.response.data);
		    			}
	    			});
	        }
		},

		computed: {
			urlAdjuntos(){
				if (this.event.CODIGO_OPORTUNIDAD) {
					return `${crm.url}/oportunidades/${this.event.CODIGO_OPORTUNIDAD}/adjuntos?redirect=${crm.url}/tareas?modalOpen=${this.event.CODIGO_TAREA}`
				}
				return null;
			}
		}
	}
</script>